import { render, staticRenderFns } from "./ColumnCountSwitcher.vue?vue&type=template&id=ea7117d0&scoped=true&"
import script from "./ColumnCountSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ColumnCountSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnCountSwitcher.vue?vue&type=style&index=0&id=ea7117d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7117d0",
  null
  
)

export default component.exports